import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getMe } from '../../services/authService';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';

const EPPrivateRoute: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);
    const [isEP, setIsEP] = React.useState<boolean>(false);

    React.useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem(TOKEN_KEY);
            if (!token) {
                localStorage.removeItem(USER_ROLE_KEY);
                setIsAuthenticated(false);
                setIsEP(false);
                return;
            }

            try {
                const userData = await getMe();
                const role = userData?.role ?? userData?.user?.role;

                if (role === 'ep') {
                    setIsAuthenticated(true);
                    setIsEP(true);
                    localStorage.setItem(USER_ROLE_KEY, 'ep');
                } else {
                    setIsAuthenticated(true);
                    setIsEP(false);
                    if (role) {
                        localStorage.setItem(USER_ROLE_KEY, role);
                    } else {
                        localStorage.removeItem(USER_ROLE_KEY);
                    }
                }
            } catch (error) {
                setIsAuthenticated(false);
                setIsEP(false);
                localStorage.removeItem(USER_ROLE_KEY);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }

    if (isAuthenticated === false) {
        return <Navigate to="/login" replace />;
    }

    if (isAuthenticated && !isEP) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
};

export default EPPrivateRoute;
